import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-master-of-computer-management',
  templateUrl: './master-of-computer-management.component.html',
  styleUrls: ['./master-of-computer-management.component.scss']
})
export class MasterOfComputerManagementComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
